import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {findDOMNode } from 'react-dom'
import _ from 'lodash'

import * as config from '../../../../config'
import { SmCartWrapper } from './SmCartWrapper'
import { extractSectorName } from  '../../../utils/functions'
import { TicketTooltip, GASelector } from './tooltips'
import { ChosenTickets } from '../../ChosenTickets';

/* eslint import/no-webpack-loader-syntax: off */
import normalizeCSS from  '!css-loader!../../../../styles/normalize.css'
import widgetCSS from  '!css-loader!../../../../styles/index.css'
import seatmapCSS from  '!css-loader!./seatmap.css'


export default class SeatMapSelector extends Component {
    constructor (props) {
        super(props);
        this.tickets = props.tickets;
        this.smEventId = props.smEventId;
        this.smPublicKey = config.SEATMAP_PUBLIC_KEY;
        this.smLibUrl = config.SEATMAP_LIB_URL;
    }

    render() {
        return (
            <iframe 
                title="Заказ билетов"
                className='seatmap-container'> 
            </iframe>
        )
    }

    componentDidMount() {
        this.prepareAccessToIframe()
        this.initTooltips()
        this.loadSeatmapToIframe()
        this.applyStyles()
    }

    prepareAccessToIframe() {
        this.iframe = findDOMNode(this)
        this.window = this.iframe.contentWindow || this.iframe
        this.document = this.iframe.contentDocument || this.window.document
    }

    initTooltips() {
        this.tooltip = new TicketTooltip(this.document)
        this.gaSelector = new GASelector(this.document, true)
    }

    hideTooltips() {
        if(this.tooltip) this.tooltip.hide()
        if(this.gaSelector) this.gaSelector.hide()
    }

    applyStyles() {
        const style = this.document.createElement('style')
        style.type = 'text/css'
        style.appendChild(this.document.createTextNode(normalizeCSS.toString()))
        style.appendChild(this.document.createTextNode(widgetCSS.toString()))
        style.appendChild(this.document.createTextNode(seatmapCSS.toString()))
        this.document.head.appendChild(style)
    }

    loadSeatmapToIframe() {
        const root_div = this.getRootDiv()
        this.loadSeatmapIntoElement(root_div)
    }

    getRootDiv() {
        this.document.write('<div id="root"></div>')
        return this.document.getElementById("root")
    }

    loadSeatmapIntoElement(root_div) {
        const seatmap_script = this.createSMScriptElement()
        seatmap_script.onload = (e) => {
            this.createSeatmapRenderer(root_div)
            this.addZoomButtons()
        }
        this.document.head.appendChild(seatmap_script)
    }

    createSMScriptElement() {
        var sm_lib= this.document.createElement('script')
        sm_lib.src = this.smLibUrl
        sm_lib.async = true
        sm_lib.type = 'text/javascript'
        return sm_lib
    }

    createSeatmapRenderer(root_div) {
        var settings = this.getSMRendererSettings()
        this.window.sm_settings = settings
        this.window.sm_root = root_div
        this.window.sm_event_id = this.smEventId;

        this.window.eval('window.sm_object = new SeatmapBookingRenderer(window.sm_root, window.sm_settings)')
        this.window.eval('window.sm_object.loadEvent(window.sm_event_id)')
        this.smRenderer = this.window.sm_object
        this.smCart = new SmCartWrapper(this.smRenderer, config.MAX_TICKETS_IN_ORDER)
    }

    addZoomButtons() {
        const buttonBlock = this.document.createElement('div')
        this.document.body.appendChild(buttonBlock)
        ReactDOM.render(
            <ZoomButtons
                onZoomIn={this.zoomIn} 
                onZoomOut={this.zoomOut} 
            />, buttonBlock)
    }

    getSMRendererSettings() {
        return {
            publicKey: this.smPublicKey,
            onCartChange: () => this.props.onChange(this.exportCart()),
            onSeatMouseEnter: (seat) => {
                this.showSeatTooltip(seat)
            },
            onSeatSelect: (seat) => {
                this.showSeatTooltip(seat)
            },
            onSeatMouseLeave: (seat) => this.hideTooltips(),
            onSectorMouseEnter: (sector) => {
                if (this.gaSelector && this.gaSelector.isActive()) {
                    return
                }
                this.showGaTooltip(sector)
            },
            onSectorMouseLeave: () => {
                this.tooltip.hide()
            },
            onSectorClick: (sector) => {
                this.showGaSelector(sector)
            },
            env: config.SEATMAP_ENVIRONMENT,
        }
    }

    zoomIn = () => {
        this.smRenderer.zoomIn()
        this.hideTooltips()
    }

    zoomOut = () => {
        this.smRenderer.zoomOut()
        this.hideTooltips()
    }

    showGaSelector = (sector) => {
        this.hideTooltips()
        if(sector.ga === true) {
            const inCart = this.smCart.getGaCount(sector.name)
            this.gaSelector.show({
                x: sector.rect.left + sector.rect.width/2,
                y: sector.rect.top + sector.rect.height/2,
                name: sector.name,
                price: sector.price,
                field_width: this.smRenderer.width,
                field_height: this.smRenderer.height,
                max: this.getGaOrderLimit(sector.name),
                inCart: inCart,
                onChange: (newCount) => {
                    this.smCart.updateGa({
                        ...sector,
                        count: newCount,
                    })
                    this.props.onChange(this.exportCart())
                }
            })
        }
    }

    showGaTooltip = (sector) => {
        this.hideTooltips()
        if (sector.ga === true) {
            this.tooltip.show({
                x: sector.rect.left + sector.rect.width/2,
                y: sector.rect.top + sector.rect.height/2,
                name: sector.name,
                price: sector.price,
                field_width: this.smRenderer.width,
                field_height: this.smRenderer.height,
            })
        }
    }

    showSeatTooltip = (seat) => {
        this.hideTooltips()
        this.tooltip.show({
            x: seat.x,
            y: seat.y,
            name: extractSectorName(seat.key),
            row_number: seat.rowNumber,
            seat_number: seat.seatName,
            price: seat.price,
            field_width: this.smRenderer.width,
            field_height: this.smRenderer.height
        })
    }

    exportCart() {
        return new ChosenTickets(this.smCart.exportCart());
    }

    getGaOrderLimit = (sectorName) => {
        const inCart = this.smCart.getGaCount(sectorName)
        const totallyAvailable = this.getGaTicketsInStockCount(sectorName)
        const availableToAdd = totallyAvailable - inCart
        const freeCartSpace = this.smCart.getAvailableForOrder()

        if (availableToAdd >  freeCartSpace) 
            return freeCartSpace + inCart
        else 
            return availableToAdd + inCart
    }

    getGaTicketsInStockCount = (sectorName) => {
        const set = _.find(this.tickets, (set) => set.name === sectorName);
        if (!set) {
            return 0;
        }
        return set.amount_available;
    }
}

class ZoomButtons extends Component {
    render () {
        return (
            <div className="seatmap-zoom-buttons">
                <div 
                    className="seatmap-zoom-button"
                    onClick={this.props.onZoomIn} >
                    +
                </div>
                <div 
                    className="seatmap-zoom-button"
                    onClick={this.props.onZoomOut} >
                    &ndash;
                </div>
            </div>
        )
    }
}
